export default function initLogin() {
    if (document.querySelector('.page-template-login')) {
        new Login(document.querySelector('.page-template-login'));
    }
}

/**
 * @param {HTMLElement} $el HTML Element
 */
class Login {
    constructor($el) {
        this.$el = $el;
        this.$btnCGUPopin = $el.querySelector('.js-cgu');
        this.$popinCGU = $el.querySelector('.popin-cgu');
        this.$btnAcceptCGU = this.$popinCGU.querySelector('.js-accept-cgu');
        this.$checkboxAcceptCGU = $el.querySelector('input.js-accept-cgu');
        this.init();
    }
    /**
     * Initialise le header dans le bon device en fonction
     * de la taille de l'écran (mobile ou desktop)
     *
     * @return {void}
     */
    init() {
        // Switch sur champs passwd
        const inputWrapperPassword = this.$el.querySelectorAll('.input-wrapper.password');

        inputWrapperPassword.forEach(container => {
            container.querySelector('.js-show-input').addEventListener('click', (evt) => {
                evt.preventDefault();
                if (!evt.target.classList.contains('visible')) {
                    container.querySelector('input').type = 'text';
                    evt.target.classList.add('visible');
                } else {
                    container.querySelector('input').type = 'password';
                    evt.target.classList.remove('visible');
                }
            });
        });

        // Affichage de la fenetre de connexion (en mobile)
        const btnShowForm = this.$el.querySelector('.js-show-form');
        const colRightLogin = this.$el.querySelector('.js-col-right');
        btnShowForm.addEventListener('click', (evt) => {
            evt.preventDefault();
            colRightLogin.classList.add('visible');
        });

        // CGU
        // Ouverture CGU
        this.$btnCGUPopin.addEventListener('click', (evt) => {
            evt.preventDefault();
            this.$popinCGU.classList.add('visible');
            document.querySelector('body').classList.add('noscroll');
        });

        // A l'acceptation des CGU dans la popin, coche la checkbox reliée dans le formulaire et cache la popin
        this.$btnAcceptCGU.addEventListener('click', (evt) => {
            evt.preventDefault();
            this.$checkboxAcceptCGU.disabled = false;
            this.$checkboxAcceptCGU.checked = true;
            this.$popinCGU.classList.remove('visible');
            document.querySelector('body').classList.remove('noscroll');
        });
    }
}
